import { apiFetch } from "../useApi";

export default async function retryCampaignIMessages(campaignId) {
  const response = await apiFetch(`/campaigns/imessages/retry`, {
    method: 'POST',
  });
  return response.json();
}
